var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import * as React from "react";
import styled from "styled-components";
var Message = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: auto;\n  width: 100%;\n  padding: 2rem;\n  h2 {\n    font-size: 2rem;\n    text-align: center;\n    margin-top: 0;\n  }\n"], ["\n  margin: auto;\n  width: 100%;\n  padding: 2rem;\n  h2 {\n    font-size: 2rem;\n    text-align: center;\n    margin-top: 0;\n  }\n"])));
var SimpleErrorBoundary = function (_super) {
  __extends(SimpleErrorBoundary, _super);
  function SimpleErrorBoundary() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      error: null,
      stack: null
    };
    return _this;
  }
  SimpleErrorBoundary.getDerivedStateFromError = function (error) {
    return {
      error: error.toString(),
      stack: error.stack
    };
  };
  SimpleErrorBoundary.prototype.componentDidCatch = function (error, info) {
    console.error(error, info);
  };
  SimpleErrorBoundary.prototype.render = function () {
    if (this.state.error) {
      return React.createElement(Message, null, React.createElement("h2", null, "Something went wrong"), React.createElement("p", null, this.state.error), React.createElement("pre", null, this.state.stack));
    }
    return this.props.children;
  };
  return SimpleErrorBoundary;
}(React.Component);
export default SimpleErrorBoundary;
var templateObject_1;